import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, NestedProperty } from "../../decorators/EntityDecorators";
import { PointOfService } from "./PointOfService.model";
import { Employee } from "./Employee.model";
import { FSTREAM_Image } from "./FSTREAM_Image.model";
import { Register } from "../../decorators/DependencyInjectionRegistreyDecorators";

@Register({
  isModelEntity: true, namespace: 'Tenant', entityName: 'Delivery'
})
export class Delivery extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [IPropretyAttribute.KeyProperty, IPropretyAttribute.Readonly]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.Readonly, IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  deliveryId!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn, IPropretyAttribute.DateRangeFilterColumn] })
  deliveryDate!: Date;

  // Pas de DateRangeFilterColumn : la plage de dates ne porte que sur la date de livraison,
  // seule propriete que le composant de liste retient.
  @PropretyAttributes({ attributes: [IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  pickupDate?: Date;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  status!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  numberOfNotificationSent!: number;

  deliveryCompany?: string;

  deliveryType?: number;

  comments?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_PointOfService!: number;

  fK_Employee?: number;

  employeeName?: string;

  fK_PickupBy?: number;

  pickupBy?: string;

  fK_Image_Signature?: number;

  fK_Image_Package?: number;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  @NestedProperty({ TargetType: Employee })
  employee?: Employee;

  @NestedProperty({ TargetType: Employee })
  pickupByEmployee?: Employee;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageSignature?: FSTREAM_Image;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imagePackage?: FSTREAM_Image;

  // Propriétés UI (non mappées)
  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  selectedPK_Pos: string[] = [];

  selectedPK_Employee?: string[];

  selectedPK_PickupBy?: string[];

  GetType(): IEntityMetaData {
    return Delivery.getMetaData();
  }
}
